import React from 'react';

const Select = ({ name, title: placeholder, options, onChange, value }) => {
	return (
		<select
			title={placeholder}
			onChange={e => onChange(e.target.value)}
			value={value}
			name={name}
			className='w-full overflow-hidden text-ellipsis rounded-full bg-light py-2 px-4 shadow-light dark:bg-dark dark:shadow-dark'
		>
			<option value="0" />
			{options &&
				options.map(({ value, label }) => (
					<option key={value} value={value}>
						{label}
					</option>
				))}
		</select>
	);
};

export default Select;
